import React, { useEffect } from "react";
import label from "../../labels/administration_en.json";

const PublishedReport = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="dashboardContentArea">
      <h5> {label.PublishedReport} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default PublishedReport;
